<template>
    <div></div>
</template>

<script>
import Session from "@/util/session";

export default {
    mounted() {
        this.initAssistant();
    },
    methods: {
        initAssistant() {
            this.$loading({
                url: '/api/operation/sys_config/read?key=chatbotConfig'
            }).then(function (res) {
                var data = res.data;
                if (data) {
                    var user = Session.getAccount(), script = document.createElement('script');
                    script.src = data.src;
                    Object.assign(script.dataset, data.config);
                    if (user) {
                        script.dataset.userId = data.env + '_' + user.companyId + '_' + user.id;
                        script.dataset.userName = user.realname;
                    }
                    script.defer = true;
                    document.head.appendChild(script);
                }
            });
        }
    }
};
</script>